import { createAsyncThunk } from "@reduxjs/toolkit";
import { getShareHistory } from "api/share";

export const downloadShareHistory = createAsyncThunk("share-history/download", async ({ metadataId }: { metadataId: string }) => {
  return getShareHistory(metadataId);
});
